import { useState, useEffect, useMemo } from "react";
import { GridLayout } from "./layout";

const ImageAssessmentComp = ({ data, onSelect }) => {
    const [images, setImages] = useState(data.map((answer, index) => ({"id":answer.quiz_answer?.image?.id,  url: answer.quiz_answer?.image?.url,
                    correct: answer.quiz_correct_answer || false,
                    chosen: answer.chosen || false})));
    


    const handleSelect = (index) => {
        
        onSelect(index)
        const extractedImages = [...images]
        extractedImages[index].chosen = !extractedImages[index].chosen
         setImages(extractedImages);
    };



    return (
        <GridLayout
            className="photo-options-quiz-grid"
            rowTemplate="auto"
            gap="16px"
        >
            {images.length === 0 ? (
                <div>No images available</div>
            ) : (
                images.map((image,index) => (
                    <div
                        key={image.id}
                        className={`photo-option-quiz ${image.chosen ? "active" : ""}`}
                        onClick={() => handleSelect(index,image)}
                    >
                        <img
                            src={image.url}
                            alt={`Option ${image.id}`}
                            className="photo-option-quiz-img"
                        />
                    </div>
                ))
            )}
        </GridLayout>
    );
};

export default ImageAssessmentComp;
